import { useCallback, useState } from "react";
import { getNewInquiryCountAsync } from "../api/InquiryApi";
import { Constants } from "../constants/constants";

interface UseNewInquiryCountReturn {
  newCount: number;
  refresh: () => Promise<void>;
}

export const useNewInquiryCount = (
  organizationId: string | undefined,
): UseNewInquiryCountReturn => {
  const [newCount, setNewCount] = useState(0);
  const token = localStorage.getItem(Constants.ACCESS_TOKEN) || "";

  const refresh = useCallback(async () => {
    if (!organizationId || !token) {
      setNewCount(0);
      return;
    }
    try {
      const res = await getNewInquiryCountAsync(token, organizationId);
      if (res.success) setNewCount(res.result ?? 0);
    } catch (err) {
      console.error(err);
    }
  }, [organizationId, token]);

  return { newCount, refresh };
};
